import * as z from "zod";

import { boardMeetingSectionWithContentsSchema } from "./board-meeting-section-with-contents";
import { boardMeetingWithPeopleSchema } from "./board-meeting-with-people";

export const boardMeetingWithDetailsSchema =
  boardMeetingWithPeopleSchema.extend({
    sections: z.array(boardMeetingSectionWithContentsSchema).default([]),
  });

export type BoardMeetingWithDetails = z.infer<
  typeof boardMeetingWithDetailsSchema
>;
